import { Row } from 'react-bootstrap';
import { IconManagement } from '../../../../../shared/Icons';
import { CampaignManagementUser } from './CampaignManagementUser';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CampaignClientManagementModal from './modal/CampaignClientManagementModal';
import { ICampaignManagement } from './dto/ICampaignManagement';
import { InternalRoutes } from '../../../../../enum/InternalRoutes';
import { useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { MUTED_TEXT_COLOR } from '../../../../../utils/constants';
import { CampaignManagementModal } from './modal/CampaignManagementModal';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';

interface ICampaignTeamCardProps {
    setUpdateManagement: React.Dispatch<React.SetStateAction<boolean>>;
    managementInfo?: ICampaignManagement;
    isLongTermDash?: boolean;
}

export function CampaignTeamCard({ managementInfo, setUpdateManagement, isLongTermDash }: ICampaignTeamCardProps) {
    const [showClientModal, setShowClientModal] = useState(false);
    const [showCampaignManagementModal, setShowCampaignManagementModal] = useState(false);
    const [campaignId, setCampaignId] = useState(0);
    const isSupplier = managementInfo?.isSupplier;
    const users = managementInfo?.isSupplier ? managementInfo?.clientUsers : managementInfo?.assignedUsers;
    const team = users?.sort((a, b) => {
        if (a.userType === 'brand_master' && b.userType !== 'brand_master') {
            return -1;
        } else if (a.userType !== 'brand_master' && b.userType === 'brand_master') {
            return 1;
        } else {
            return 0;
        }
    });
    const title = useSelector((state: IAllStates) => state.selectedCampaign?.campaign?.title);
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const closeClientModal = () => {
        setShowClientModal(false);
        setUpdateManagement(prevState => !prevState);
    };

    const openMessageTab = () => {
        navigate(`${InternalRoutes.BRAND_CAMPAIGN_MESSAGES}/${id}`);
    };

    const showModalAndSetId = (id: string) => {
        setCampaignId(+id);
        setShowCampaignManagementModal(true);
    };
    const closeModal = () => {
        setShowCampaignManagementModal(false);
        setUpdateManagement(prevState => !prevState);
    };

    return (
        <>
            <CampaignManagementModal
                show={showCampaignManagementModal}
                closeModal={closeModal}
                openModal={() => setShowCampaignManagementModal(true)}
                campaignId={campaignId}
                assignedUsers={team ?? []}
                campaignName={title ?? ''}
                isClientTeam={true}
            />
            <CampaignClientManagementModal show={showClientModal} onClose={closeClientModal} isSupplier={isSupplier} />
            <div className="d-flex justify-content-between align-items-center">
                {isSupplier ? (
                    <h6 className="textHover cursor-pointer" onClick={() => setShowClientModal(true)}>
                        <IconManagement
                            width="20"
                            height="20"
                            color={MUTED_TEXT_COLOR}
                            classes={' mr-2'}
                        ></IconManagement>
                        {t('brand.campaign.dashboard.campaign_management.client_team')}
                    </h6>
                ) : (
                    <h6 className="textHover cursor-pointer" onClick={() => setShowClientModal(true)}>
                        <IconManagement
                            width="20"
                            height="20"
                            color={MUTED_TEXT_COLOR}
                            classes={' mr-2'}
                        ></IconManagement>
                        {t('brand.campaign.dashboard.campaign_management.agency_team')}
                    </h6>
                )}
            </div>
            {(team?.length ?? 0) > 0 && (
                <Row className="align-items-center mt-2">
                    {team?.slice(0, 2)?.map(userData => {
                        return (
                            <CampaignManagementUser
                                user={userData}
                                classParent="pr-0"
                                brandCompany={managementInfo?.ownedBy?.brandCompany}
                                key={userData?.id}
                                hasMultipleUsers={team?.length > 1}
                            />
                        );
                    })}
                    {(team?.length ?? 0) > 2 && (
                        <div className="col-auto pl-1">
                            <Tooltip
                                id="white-tooltip"
                                title={
                                    <>
                                        {team?.slice(2)?.map(campaign => (
                                            <div className="text-dark" key={campaign?.id}>
                                                <CampaignManagementUser
                                                    user={campaign}
                                                    brandCompany={managementInfo?.ownedBy?.brandCompany}
                                                    key={campaign?.id}
                                                    classParent="py-2"
                                                />
                                            </div>
                                        ))}
                                    </>
                                }
                                placement="left"
                                className="cursor-pointer"
                            >
                                <span
                                    className="icon-round bg-white text-primary shadow font-weight-semi-bold min-width-max-content"
                                    style={{ width: 36, maxWidth: 36 }}
                                >
                                    + {(team?.length ?? 0) - 2}
                                </span>
                            </Tooltip>
                        </div>
                    )}
                </Row>
            )}
            <div className="d-flex justify-content-end mt-3">
                {isSupplier && (
                    <a
                        className="cursor-pointer text-uppercase mr-3"
                        onClick={() => {
                            showModalAndSetId(id!);
                        }}
                    >
                        {t('brand.campaign.dashboard.campaign_management.manage')}
                    </a>
                )}
                <a
                    className="cursor-pointer text-uppercase"
                    onClick={() => (isSupplier || isLongTermDash ? setShowClientModal(true) : openMessageTab())}
                >
                    {isSupplier
                        ? t('brand.campaign.dashboard.campaign_management.share')
                        : t('brand.campaign.dashboard.need_assistance')}
                </a>
            </div>
        </>
    );
}
